import { openAuthModal } from "../_shared/auth/use-auth-modal";

export function initJoinProgramButtonBlocks(): void {
	const buttons = document.querySelectorAll<HTMLButtonElement>(
		"button.wp-block-leat-join-program-button[data-text]",
	);
	for (const button of buttons) {
		if (button.dataset.leatJoinBound === "1") continue;
		button.dataset.leatJoinBound = "1";

		const enrollmentStatus =
			(button.dataset.enrollmentStatus as "guest" | "loggedInNotEnrolled") ||
			"guest";
		const prefillEmail = button.dataset.email || "";
		const copy = {
			modalTitle: button.dataset.modalTitle || "",
			submitText: button.dataset.submitText || "",
			successTitle: button.dataset.successTitle || "",
			successMessage: button.dataset.successMessage || "",
			accountCreationNote: button.dataset.accountCreationNote || "",
		};

		button.addEventListener("click", (e) => {
			e.preventDefault();
			openAuthModal({
				intent: enrollmentStatus === "guest" ? "signup" : "join",
				prefillEmail,
				copy,
			});
		});
	}
}

if (typeof document !== "undefined") {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initJoinProgramButtonBlocks);
	} else {
		initJoinProgramButtonBlocks();
	}
}
